import { getPromoVideo } from '@/lib/promo-video'

interface PromoVideoFrameProps {
  language: string
  testId: string
  className?: string
}

export function PromoVideoFrame({ language, testId, className = '' }: PromoVideoFrameProps) {
  const promoVideo = getPromoVideo(language)

  return (
    <div
      data-testid={testId}
      className={`relative aspect-video w-full overflow-hidden rounded-2xl ${className}`}
    >
      <iframe
        className="absolute inset-0 size-full"
        src={promoVideo.embedUrl}
        title={promoVideo.title}
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        referrerPolicy="strict-origin-when-cross-origin"
        allowFullScreen
      />
    </div>
  )
}
